import React, { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import couponimg from "../../assets/images/icons/applyCouponIcon.svg";

const CouponModal = ({ isOpen, onClose, appliedCoupon, setAppliedCoupon, setCoupons, coupons }) => {
  const [enteredCoupon, setEnteredCoupon] = useState("");
  const [error, setError] = useState("");
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  // const coupons = [
  //   { id: 1, code: "PREPAIDOFF", description: "5% off on Prepaid Orders", available: true },
  //   { id: 2, code: "NEWUSER50", description: "Flat ₹50 off for new users", available: true },
  //   { id: 3, code: "FESTIVE10", description: "10% off on Festive Sale", available: false },
  //   { id: 4, code: "LEHANGA100", description: "₹100 off on all Lehangas", available: false },
  //   { id: 5, code: "BUMPERSALE", description: "10% off on Orders above ₹10,000", available: false }
  // ];

  // Map coupons in the required format
  coupons = coupons.map((coupon) => ({
    id: coupon._id,
    code: coupon.code,
    description: coupon.description || "Flat ₹50 off for new users",
    available: coupon.isActive,
  }));

  const availableOffers = coupons.filter((coupon) => coupon.available);
  const unavailableOffers = coupons.filter((coupon) => !coupon.available);

  // ✅ Pass the list of available coupons to Cart.jsx
  useEffect(() => {
    setCoupons(availableOffers);
  }, [setCoupons]);

  const applyCoupon = (couponCode) => {
    const foundCoupon = availableOffers.find((coupon) => coupon.code === couponCode);
    if (foundCoupon) {
      setAppliedCoupon(foundCoupon);
      setSelectedCoupon(foundCoupon.code);
      setError("");
    } else {
      setError("Invalid Coupon Code");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="full-screen-modal">
      <div className="modal-header">
        <IoIosArrowBack onClick={onClose} className="back-icon" />
        <h5 className="header-text">Offers and Discounts</h5>
      </div>

      <div className="apply-input">
        <input
          type="text"
          placeholder="Enter Coupon Code"
          className="input-box"
          value={enteredCoupon}
          onChange={(e) => setEnteredCoupon(e.target.value.toUpperCase())}
        />
        <button className="applybtn" onClick={() => applyCoupon(enteredCoupon)}>
          APPLY
        </button>
      </div>

      {error && <p className="error-message">{error}</p>}

      <div className="coupon-body">
        <h6>Available Offers</h6>
        <div className="coupon-section">
          {availableOffers.length > 0 ? (
            availableOffers.map((coupon) => (
                <div className="coupon-item1">
                  <div className="coupon-details1">
                    <div className="coupon-icon">
                      <i className="fas fa-tag"></i>
                    </div>
                    <div className="coupon-text">
                      <div className="coupon-detail">
                        <span className="coupon-code">{coupon.code}</span>
                        <button className="remove-coupon">Remove</button>
                      </div>
                      <div className="coupon-description">
                        {coupon.description}
                      </div>
                    </div>
                  </div>
                </div>
            ))
          ) : (
            <p>No available offers</p>
          )}
        </div>

        <h6 className="UnavailbleHeading">Other Offers (Not Applicable)</h6>
        <div className="coupon-section">
          {unavailableOffers.length > 0 ? (
            unavailableOffers.map((coupon) => (
                <div className="coupon-item1">
                  <div className="coupon-details1">
                    <div className="coupon-icon">
                      <i className="fas fa-tag"></i>
                    </div>
                    <div className="coupon-text">
                      <div className="coupon-detail">
                        <span className="coupon-code">{coupon.code}</span>
                        <button className="remove-coupon" disabled>APPLY</button>
                      </div>
                      <div className="coupon-description">
                        {coupon.description}
                      </div>
                    </div>
                  </div>
                </div>
            ))
          ) : (
            <p>No other offers</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CouponModal;
